import { render, staticRenderFns } from "./IntegracaoForm.vue?vue&type=template&id=7130b49d"
import script from "./IntegracaoForm.vue?vue&type=script&lang=js"
export * from "./IntegracaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports